// Detects whether we're running as an installed / native app (PWA standalone,
// iOS home-screen, or wrapped in Capacitor) vs a normal browser tab.
// In app mode we drop the marketing site chrome (nav/footer) and honour the
// device safe-area insets so the experience feels native — regular browser
// visitors are unaffected.
export function isAppMode() {
  try {
    if (typeof window === "undefined") return false;
    if (window.Capacitor?.isNativePlatform?.()) return true;      // Capacitor native shell
    if (window.navigator.standalone === true) return true;         // iOS installed PWA
    const mm = window.matchMedia;
    if (mm && (mm("(display-mode: standalone)").matches || mm("(display-mode: fullscreen)").matches)) return true;
    // ?app=1 is honoured for the current load only (used for previewing app mode) — not persisted,
    // so a browser visitor never gets stranded without the site navigation.
    const sp = new URLSearchParams(window.location.search);
    return sp.get("app") === "1";
  } catch {
    return false;
  }
}
